class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.stopPropagation(); // Stop bubbling immediately
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (this.summaryToggle.contains(event.target)) return; // Ignore click if it came from the toggle
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);

    // JS ANIMATION TRIGGER (Double Frame Delay)
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.classList.add('animate-in');
      });
    });

    setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
    });
    // document.body.classList.add('overflow-hidden'); // COMMENTED OUT TO PREVENT SCROLL TRIGGER

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    this.classList.remove('animate-in'); // REMOVE TRIGGER IMMEDIATELY
    document.body.removeEventListener('click', this.onBodyClickEvent);
    // document.body.classList.remove('overflow-hidden'); // COMMENTED OUT TO PREVENT SCROLL TRIGGER
  }
}

customElements.define('details-modal', DetailsModal);
